export default __webpack_public_path__ + "static/media/divider-blue.c21229aa.svg";